import React from 'react';
import {
    Box,
    Typography,
    IconButton,
    Avatar,
    useTheme,
    useMediaQuery
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { styles } from './CryptoModalHeaderCss';

const CryptoModalHeader = ({ onClose }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={styles.headerBox(isMobile, theme)}>
            <Box sx={styles.backgroundPattern} />
            <Box sx={styles.contentBox(isMobile)}>
                <Avatar sx={styles.avatar(isMobile)}>
                    <AccountBalanceWalletIcon sx={styles.walletIcon(isMobile, theme)} />
                </Avatar>
                <Box>
                    <Typography variant={isMobile ? "subtitle1" : "h6"} sx={styles.title(theme)}>
                        Add Crypto Wallet
                    </Typography>
                    <Typography variant="body2" sx={styles.subtitle(theme)}>
                        Link your external crypto wallet
                    </Typography>
                </Box>
                <IconButton
                    onClick={onClose}
                    sx={styles.closeButton(isMobile, theme)}
                >
                    <CloseIcon fontSize={isMobile ? "small" : "medium"} />
                </IconButton>
            </Box>
        </Box>
    );
};

export default CryptoModalHeader;

